import { Dispatch } from '@reduxjs/toolkit';
import ky from 'ky';
import { openDB, IDBPDatabase, deleteDB } from 'idb';

import { RootState } from './rootReducer'
import { dbGet, clearAllDataToLoad, getSliceData, clearAllDataToSave, dbSave, loadDb } from './workBackendSlice';
import { UserDbHashType, initializeUsers, saveUsers } from './userDbSlice';
import { FolderDbHashType, initializeFolders, saveFolders, signUpFolders } from './folderDbSlice';
import { BookDbHashType, initializeBooks, saveBooks, signUpBooks } from './bookDbSlice';
import { SheetDbHashType, initializeSheets, saveSheets, signUpSheets } from './sheetDbSlice';
import { SheetInformationDbHashType, initializeSheetInformations, saveSheetInformations, signUpSheetInformations} from './sheetInformationDbSlice';
import { PaletteDbHashType, initializePalettes, savePalettes, signUpPalettes } from './paletteDbSlice';
import { CardTemplateDbHashType, initializeCardTemplates, saveCardTemplates, signUpCardTemplates } from './cardTemplateDbSlice';
import { CardTemplateAttributeDbHashType, initializeCardTemplateAttributes, saveCardTemplateAttributes, signUpCardTemplateAttributes } from './cardTemplateAttributeDbSlice';
import { CardTemplateShapeDbHashType, initializeCardTemplateShapes, saveCardTemplateShapes, signUpCardTemplateShapes } from './cardTemplateShapeDbSlice';
import { CardDbHashType, initializeCards, saveCards, signUpCards } from './cardDbSlice';
import { CardAttributeDbHashType, initializeCardAttributes, saveCardAttributes, signUpCardAttributes } from './cardAttributeDbSlice';
import { CardShapeDbHashType, initializeCardShapes, saveCardShapes, signUpCardShapes } from './cardShapeDbSlice';
import { MemoCardContentDbHashType, initializeMemoCardContents, saveMemoCardContents, signUpMemoCardContents } from './memoCardContentDbSlice';
import { UiCardItemDbHashType, initializeUiCardItems, saveUiCardItems, signUpUiCardItems } from './uiCardItemDbSlice';
import { DrawCardContentDbHashType, initializeDrawCardContents, saveDrawCardContents, signUpDrawCardContents } from './drawCardContentDbSlice';
import { UiCardSampleDataDbHashType, initializeUiCardSampleDatas, saveUiCardSampleDatas, signUpUiCardSampleDatas } from './uiCardSampleDataDbSlice';
import { CardCodeTemplateDbHashType, initializeCardCodeTemplates, saveCardCodeTemplates, signUpCardCodeTemplates } from './cardCodeTemplateDbSlice';
import { CardCodeDbHashType, initializeCardCodes, saveCardCodes, signUpCardCodes } from './cardCodeDbSlice';
import { ArrowDbHashType, initializeArrows, saveArrows, signUpArrows } from './arrowDbSlice';
import { AlbumDbHashType, initializeAlbums, saveAlbums, signUpAlbums } from './albumDbSlice';
import { ImageDbHashType, initializeImages, saveImages, signUpImages } from './imageDbSlice';
import { SheetTreeDbHashType, initializeSheetTrees, saveSheetTrees, signUpSheetTrees } from './sheetTreeDbSlice';
import { RelationUserFolderDbHashType, initializeRelationUserFolders, saveRelationUserFolders, signUpRelationUserFolders } from './relationUserFolderDbSlice';
import { RelationUserBookDbHashType, initializeRelationUserBooks, saveRelationUserBooks, signUpRelationUserBooks } from './relationUserBookDbSlice';
import { RelationUserPaletteDbHashType, initializeRelationUserPalettes, saveRelationUserPalettes, signUpRelationUserPalettes } from './relationUserPaletteDbSlice';
import { RelationUserCardTemplateDbHashType, initializeRelationUserCardTemplates, saveRelationUserCardTemplates, signUpRelationUserCardTemplates } from './relationUserCardTemplateDbSlice';
import { RelationFolderBookDbHashType, initializeRelationFolderBooks, saveRelationFolderBooks, signUpRelationFolderBooks } from './relationFolderBookDbSlice';
import { RelationPaletteCardTemplateDbHashType, initializeRelationPaletteCardTemplates, saveRelationPaletteCardTemplates, signUpRelationPaletteCardTemplates } from './relationPaletteCardTemplateDbSlice';
import { RelationUserAlbumDbHashType, initializeRelationUserAlbums, saveRelationUserAlbums, signUpRelationUserAlbums } from './relationUserAlbumDbSlice';
import { RelationUserImageDbHashType, initializeRelationUserImages, saveRelationUserImages, signUpRelationUserImages } from './relationUserImageDbSlice';
import { RelationAlbumImageDbHashType, initializeRelationAlbumImages, saveRelationAlbumImages, signUpRelationAlbumImages } from './relationAlbumImageDbSlice';
import { LatelyCardTemplateDbHashType, initializeLatelyCardTemplates, saveLatelyCardTemplates, signUpLatelyCardTemplates } from './latelyCardTemplateDbSlice';
import { LatelyImageDbHashType, initializeLatelyImages, saveLatelyImages, signUpLatelyImages } from './latelyImageDbSlice';
import { JointBookDbHashType, initializeJointBooks, saveJointBooks, signUpJointBooks } from './jointBookDbSlice';
import { PalettePermissionDbHashType, initializePalettePermissions, savePalettePermissions, signUpPalettePermissions } from './palettePermissionDbSlice';
import { CardTemplatePermissionDbHashType, initializeCardTemplatePermissions, saveCardTemplatePermissions, signUpCardTemplatePermissions } from './cardTemplatePermissionDbSlice';
import { JointPaletteDbHashType, initializeJointPalettes, saveJointPalettes, signUpJointPalettes } from './jointPaletteDbSlice';
import { StatusJointPaletteDbHashType, initializeStatusJointPalettes, saveStatusJointPalettes, signUpStatusJointPalettes } from './statusJointPaletteDbSlice';
import { StandbyPaletteJoinedDbHashType, initializeStandbyPaletteJoineds, saveStandbyPaletteJoineds, signUpStandbyPaletteJoineds } from './standbyPaletteJoinedDbSlice';
import { StandbyCardTemplateJoinedDbHashType, initializeStandbyCardTemplateJoineds, saveStandbyCardTemplateJoineds, signUpStandbyCardTemplateJoineds } from './standbyCardTemplateJoinedDbSlice';
import { StandbyRelationPaletteCardTemplateJoinedDbHashType, initializeStandbyRelationPaletteCardTemplateJoineds, saveStandbyRelationPaletteCardTemplateJoineds, signUpStandbyRelationPaletteCardTemplateJoineds } from './standbyRelationPaletteCardTemplateJoinedDbSlice';
import { StandbyPalettePermissionJoinedDbHashType, initializeStandbyPalettePermissionJoineds, saveStandbyPalettePermissionJoineds, signUpStandbyPalettePermissionJoineds } from './standbyPalettePermissionJoinedDbSlice';
import { StandbyCardTemplatePermissionJoinedDbHashType, initializeStandbyCardTemplatePermissionJoineds, saveStandbyCardTemplatePermissionJoineds, signUpStandbyCardTemplatePermissionJoineds } from './standbyCardTemplatePermissionJoinedDbSlice';
import { initializeUserCondition, saveUserConditions, UserConditionHashType } from './userConditionSlice';
import { NoteDbHashType, initializeNotes, saveNotes, signUpNotes } from './noteDbSlice';

import { Hash, localSave, localDelete } from '../general';
import { apiURL } from '../components/DigimagiProvider';

let dbPromise: Promise<IDBPDatabase> | null;
const DB_NAME = 'digimagi-local-db';
const DB_VERSION = 1;

const tabId = crypto.randomUUID();
const channel = new BroadcastChannel('db-sync');

channel.onmessage = async (ev) => {
  const msg = ev.data;
  if (msg === 'close-db' && dbPromise) {
    const db = await dbPromise;
    db.close();
    dbPromise = null;
    channel.postMessage('db-closed');
  } else if (typeof msg === 'object' && msg?.type === 'reload' && msg.sourceTabId !== tabId) {
    console.log(`[${tabId}] 他タブからリロード指示 → 実行`);
    location.reload();
  }
};

export const initLocalDB = () => {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        for (const storeName of dbKeys) {
          if (!db.objectStoreNames.contains(storeName)) {
            db.createObjectStore(storeName, { keyPath: 'id' });
          }
        }
      }
    });
  }
  return dbPromise;
}
export const resetLocalDB = async () => {
  const channel = new BroadcastChannel('db-sync');

  // DBを開いているタブに閉じるよう通知
  channel.postMessage('close-db');

  // 応答を待つ（5秒以内）
  const closed = await new Promise<boolean>((resolve) => {
    const timeout = setTimeout(() => resolve(false), 5000);
    channel.onmessage = (ev) => {
      if (ev.data === 'db-closed') {
        clearTimeout(timeout);
        resolve(true);
      }
    };
  });

  if (!closed) {
    throw new Error('DBを開いている他のタブが応答しなかったので、削除を中止します。');
  }

  // 自タブの接続も閉じる
  if (dbPromise) {
    const db = await dbPromise;
    db.close();
    dbPromise = null;
  }

  await deleteDB(DB_NAME, {
    blocked() {
      console.warn('削除がブロックされました。他プロセスで使用中の可能性があります。')
    }
  });
  await initLocalDB();

  channel.postMessage({ type: 'reload', sourceTabId: tabId });
}

// Backend有無チェック
let isBackendExist: boolean | undefined = undefined;
export const setIsBackendExist = (value: boolean) => {
  isBackendExist = value;
}
export const isLogined = () => {
  return Boolean(isBackendExist);
}

// Data有無チェック
export const hasData = async (): Promise<boolean> => {
  if (isLogined()) return true;
  else {
    const db = await initLocalDB();
    const res = await db.getAll('users');
    return res.length >= 1;
  }
}

export const loadData = async (key: DbKeyType) => {
  if (key === 'userConditions') {
    const temporaryJson = sessionStorage.getItem(key);
    const json = localStorage.getItem(key);
    return temporaryJson ? JSON.parse(temporaryJson) : json ? JSON.parse(json) : null;
  } else if (isLogined()) {
    const res = getSliceData(key);
    return res;
  } else {
    const db = await initLocalDB();
    const values = await db.getAll(key) as { id: string; }[];
    const hash: Hash<Object> = {};
    values.forEach(value => {
      const { id, ...obj } = value;
      hash[id] = obj;
    })
    return hash;
  }
}

export const saveAllData = (key: string, values: Hash<Object>) => {
  if (isLogined()) {
    try {
      const ids = Object.keys(values);
      if (ids.length >= 1) {
        ky.post(`${apiURL}save_datas`, { json: { key, values } });
      } else console.log(`no data in ${key}`)
    } catch (err) {
      console.log(err)
    }
  } else localSave([key], values);
}

export const saveData = (key: DbKeyType, id: string, value: Object) => {
  if (isLogined()) {
    try {
      const sendData = { key, id, value };
      ky.post(`${apiURL}save_data`, { json: sendData });
    } catch (err) {
      console.log(err)
    }
  } else localSave([key, id], value);
}

export const deleteData = (key: DbKeyType, id: string) => {
  if (isLogined()) {
    try {
      const sendData = { key, id };
      ky.post(`${apiURL}delete_data`, { json: sendData });
    } catch (err) {
      console.log(err)
    }
  } else localDelete([key, id]);
}

export type DbKeyType = 'users' |
  'folders' |
  'books' |
  'sheets' |
  'sheetInformations' |
  'palettes' |
  'cardTemplates' |
  'cardTemplateAttributes' |
  'cardTemplateShapes' |
  'cards' |
  'cardAttributes' |
  'cardShapes' |
  'memoCardContents' |
  'uiCardItems' |
  'drawCardContents' |
  'uiCardSampleDatas' |
  'cardCodeTemplates' |
  'cardCodes' |
  'arrows' |
  'albums' |
  'images' |
  'sheetTrees' |
  'relationUserFolders' |
  'relationUserBooks' |
  'relationUserPalettes' |
  'relationUserCardTemplates' |
  'relationFolderBooks' |
  'relationPaletteCardTemplates' |
  'relationUserAlbums' |
  'relationUserImages' |
  'relationAlbumImages' |
  'latelyCardTemplates' |
  'latelyImages' |
  'jointBooks' |
  'palettePermissions' |
  'cardTemplatePermissions' |
  'jointPalettes' |
  'statusJointPalettes' |
  'standbyPaletteJoineds' |
  'standbyCardTemplateJoineds' |
  'standbyRelationPaletteCardTemplateJoineds' |
  'standbyPalettePermissionJoineds' |
  'standbyCardTemplatePermissionJoineds' |
  'userConditions' |
  'notes'

export const dbKeys: DbKeyType[] = [
  'users',
  'folders',
  'books',
  'sheets',
  'sheetInformations',
  'palettes',
  'cardTemplates',
  'cardTemplateAttributes',
  'cardTemplateShapes',
  'cards',
  'cardAttributes',
  'cardShapes',
  'memoCardContents',
  'uiCardItems',
  'drawCardContents',
  'uiCardSampleDatas',
  'cardCodeTemplates',
  'cardCodes',
  'arrows',
  'albums',
  'images',
  'sheetTrees',
  'relationUserFolders',
  'relationUserBooks',
  'relationUserPalettes',
  'relationUserCardTemplates',
  'relationFolderBooks',
  'relationPaletteCardTemplates',
  'relationUserAlbums',
  'relationUserImages',
  'relationAlbumImages',
  'latelyCardTemplates',
  'latelyImages',
  'jointBooks',
  'palettePermissions',
  'cardTemplatePermissions',
  'jointPalettes',
  'statusJointPalettes',
  'standbyPaletteJoineds',
  'standbyCardTemplateJoineds',
  'standbyRelationPaletteCardTemplateJoineds',
  'standbyPalettePermissionJoineds',
  'standbyCardTemplatePermissionJoineds',
  'userConditions',
  'notes'
]

export const isDbKeyType = (word: any): word is DbKeyType => {
  return dbKeys.includes(word);
}

export type AllDbHash = {
  'users': UserDbHashType,
  'folders': FolderDbHashType,
  'books': BookDbHashType,
  'sheets': SheetDbHashType,
  'sheetInformations': SheetInformationDbHashType,
  'palettes': PaletteDbHashType,
  'cardTemplates': CardTemplateDbHashType,
  'cardTemplateAttributes': CardTemplateAttributeDbHashType,
  'cardTemplateShapes': CardTemplateShapeDbHashType,
  'cards': CardDbHashType,
  'cardAttributes': CardAttributeDbHashType,
  'cardShapes': CardShapeDbHashType,
  'memoCardContents': MemoCardContentDbHashType,
  'uiCardItems': UiCardItemDbHashType,
  'drawCardContents': DrawCardContentDbHashType,
  'uiCardSampleDatas': UiCardSampleDataDbHashType,
  'cardCodeTemplates': CardCodeTemplateDbHashType,
  'cardCodes': CardCodeDbHashType,
  'arrows': ArrowDbHashType,
  'albums': AlbumDbHashType,
  'images': ImageDbHashType,
  'sheetTrees': SheetTreeDbHashType,
  'relationUserFolders': RelationUserFolderDbHashType,
  'relationUserBooks': RelationUserBookDbHashType,
  'relationUserPalettes': RelationUserPaletteDbHashType,
  'relationUserCardTemplates': RelationUserCardTemplateDbHashType,
  'relationFolderBooks': RelationFolderBookDbHashType,
  'relationPaletteCardTemplates': RelationPaletteCardTemplateDbHashType,
  'relationUserAlbums': RelationUserAlbumDbHashType,
  'relationUserImages': RelationUserImageDbHashType,
  'relationAlbumImages': RelationAlbumImageDbHashType,
  'latelyCardTemplates': LatelyCardTemplateDbHashType,
  'latelyImages': LatelyImageDbHashType,
  'jointBooks': JointBookDbHashType,
  'palettePermissions': PalettePermissionDbHashType,
  'cardTemplatePermissions': CardTemplatePermissionDbHashType,
  'jointPalettes': JointPaletteDbHashType,
  'statusJointPalettes': StatusJointPaletteDbHashType,
  'standbyPaletteJoineds': StandbyPaletteJoinedDbHashType,
  'standbyCardTemplateJoineds': StandbyCardTemplateJoinedDbHashType,
  'standbyRelationPaletteCardTemplateJoineds': StandbyRelationPaletteCardTemplateJoinedDbHashType,
  'standbyPalettePermissionJoineds': StandbyPalettePermissionJoinedDbHashType,
  'standbyCardTemplatePermissionJoineds': StandbyCardTemplatePermissionJoinedDbHashType,
  'userConditions': UserConditionHashType,
  'notes': NoteDbHashType
}

export const initializeSlices = () => {
  return (dispatch: Dispatch<any>) => {
    clearAllDataToLoad();
    dispatch(initializeUsers());
    dispatch(initializeFolders());
    dispatch(initializeBooks());
    dispatch(initializeSheets());
    dispatch(initializeSheetInformations());
    dispatch(initializePalettes());
    dispatch(initializeCardTemplates());
    dispatch(initializeCardTemplateAttributes());
    dispatch(initializeCardTemplateShapes());
    dispatch(initializeCards());
    dispatch(initializeCardAttributes());
    dispatch(initializeCardShapes());
    dispatch(initializeMemoCardContents());
    dispatch(initializeUiCardItems());
    dispatch(initializeDrawCardContents());
    dispatch(initializeUiCardSampleDatas());
    dispatch(initializeCardCodeTemplates());
    dispatch(initializeCardCodes());
    dispatch(initializeArrows());
    dispatch(initializeAlbums());
    dispatch(initializeImages());
    dispatch(initializeSheetTrees());
    dispatch(initializeRelationUserFolders());
    dispatch(initializeRelationUserBooks());
    dispatch(initializeRelationUserPalettes());
    dispatch(initializeRelationUserCardTemplates());
    dispatch(initializeRelationFolderBooks());
    dispatch(initializeRelationPaletteCardTemplates());
    dispatch(initializeRelationUserAlbums());
    dispatch(initializeRelationUserImages());
    dispatch(initializeRelationAlbumImages());
    dispatch(initializeLatelyCardTemplates());
    dispatch(initializeLatelyImages());
    dispatch(initializeJointBooks());
    dispatch(initializePalettePermissions());
    dispatch(initializeCardTemplatePermissions());
    dispatch(initializeJointPalettes());
    dispatch(initializeStatusJointPalettes());
    dispatch(initializeStandbyPaletteJoineds());
    dispatch(initializeStandbyCardTemplateJoineds());
    dispatch(initializeStandbyRelationPaletteCardTemplateJoineds());
    dispatch(initializeStandbyPalettePermissionJoineds());
    dispatch(initializeStandbyCardTemplatePermissionJoineds());
    dispatch(initializeUserCondition());
    dispatch(initializeNotes());
  }
}

//
export const loadAllDb = () => {
  return async (dispatch: Dispatch<any>) => {
    if (isLogined()) await dbGet();
    dbKeys.forEach(key => dispatch(loadDb(key)))
  }
}

export const saveAllDb = () => {
  return (dispatch: Dispatch<any>, getState: () => RootState) => {
    // dispatch(deleteUnusedImages(getState().cardDb.cards));
    dispatch(saveUsers());
    dispatch(saveFolders());
    dispatch(saveBooks());
    dispatch(saveSheets());
    dispatch(saveSheetInformations());
    dispatch(savePalettes());
    dispatch(saveCardTemplates());
    dispatch(saveCardTemplateAttributes());
    dispatch(saveCardTemplateShapes());
    dispatch(saveCards());
    dispatch(saveCardAttributes());
    dispatch(saveCardShapes());
    dispatch(saveMemoCardContents());
    dispatch(saveUiCardItems());
    dispatch(saveDrawCardContents());
    dispatch(saveUiCardSampleDatas());
    dispatch(saveCardCodeTemplates());
    dispatch(saveCardCodes());
    dispatch(saveArrows());
    dispatch(saveAlbums());
    dispatch(saveImages());
    dispatch(saveSheetTrees());
    dispatch(saveRelationUserFolders());
    dispatch(saveRelationUserBooks());
    dispatch(saveRelationUserPalettes());
    dispatch(saveRelationUserCardTemplates());
    dispatch(saveRelationFolderBooks());
    dispatch(saveRelationPaletteCardTemplates());
    dispatch(saveRelationUserAlbums());
    dispatch(saveRelationUserImages());
    dispatch(saveRelationAlbumImages());
    dispatch(saveLatelyCardTemplates());
    dispatch(saveLatelyImages());
    dispatch(saveJointBooks());
    dispatch(savePalettePermissions());
    dispatch(saveCardTemplatePermissions());
    dispatch(saveJointPalettes());
    dispatch(saveStatusJointPalettes());
    dispatch(saveStandbyPaletteJoineds());
    dispatch(saveStandbyCardTemplateJoineds());
    dispatch(saveStandbyRelationPaletteCardTemplateJoineds());
    dispatch(saveStandbyPalettePermissionJoineds());
    dispatch(saveStandbyCardTemplatePermissionJoineds());
    dispatch(saveUserConditions());
    dispatch(saveNotes());
  }
}

export type SignUpPayload = {
  newId: string;
  oldId: string;
}
export const signUpAllDb = (payload: SignUpPayload, callback?: () => void) => {
  return (dispatch: Dispatch<any>) => {
    clearAllDataToSave();
    dispatch(signUpFolders(payload));
    dispatch(signUpBooks(payload));
    dispatch(signUpSheets(payload));
    dispatch(signUpSheetInformations(payload));
    dispatch(signUpPalettes(payload));
    dispatch(signUpCardTemplates(payload));
    dispatch(signUpCardTemplateAttributes(payload));
    dispatch(signUpCardTemplateShapes(payload));
    dispatch(signUpCards(payload));
    dispatch(signUpCardAttributes(payload));
    dispatch(signUpCardShapes(payload));
    dispatch(signUpMemoCardContents(payload));
    dispatch(signUpUiCardItems(payload));
    dispatch(signUpDrawCardContents(payload));
    dispatch(signUpUiCardSampleDatas(payload));
    dispatch(signUpCardCodeTemplates(payload));
    dispatch(signUpCardCodes(payload));
    dispatch(signUpArrows(payload));
    dispatch(signUpAlbums(payload));
    dispatch(signUpImages(payload));
    dispatch(signUpSheetTrees(payload));
    dispatch(signUpRelationUserFolders(payload));
    dispatch(signUpRelationUserBooks(payload));
    dispatch(signUpRelationUserPalettes(payload));
    dispatch(signUpRelationUserCardTemplates(payload));
    dispatch(signUpRelationFolderBooks(payload));
    dispatch(signUpRelationPaletteCardTemplates(payload));
    dispatch(signUpRelationUserAlbums(payload));
    dispatch(signUpRelationUserImages(payload));
    dispatch(signUpRelationAlbumImages(payload));
    dispatch(signUpLatelyCardTemplates(payload));
    dispatch(signUpLatelyImages(payload));
    dispatch(signUpJointBooks(payload));
    dispatch(signUpPalettePermissions(payload));
    dispatch(signUpCardTemplatePermissions(payload));
    dispatch(signUpJointPalettes(payload));
    dispatch(signUpStatusJointPalettes(payload));
    dispatch(signUpStandbyPaletteJoineds(payload));
    dispatch(signUpStandbyCardTemplateJoineds(payload));
    dispatch(signUpStandbyRelationPaletteCardTemplateJoineds(payload));
    dispatch(signUpStandbyPalettePermissionJoineds(payload));
    dispatch(signUpStandbyCardTemplatePermissionJoineds(payload));
    dispatch(signUpNotes(payload));
    dbSave(true, callback);
  }
}
